export const boldString = str => {
  return str.replace(
    // eslint-disable-next-line
    /\*{2}(?=[^\s\*])(.*?)([^\s\*])\*{2}/gi,
    s => `<b>${s.replace(/\*/g, '')}</b>`
  )
}

export const italicString = str => {
  return str.replace(
    // eslint-disable-next-line
    /_{2}(?=[^\s_])(.*?)([^\s_])_{2}/gi,
    s => `<i>${s.replace(/_/g, '')}</i>`
  )
}

export const withColorString = str => {
  return str.replace(
    // eslint-disable-next-line
    /\{color:([^}]+)\}(.*?)\{\/color\}/gi,
    (match, color, text) => `<span style="color:${color}">${text}</span>`
  )
}

export const keyFromString = (str, length = 10) => {
  return (
    str.substr(0, length / 2) + str.substr(str.length - length / 2, str.length)
  )
}
